import { QueryClientProvider } from '@tanstack/react-query'
import type { ReactNode } from 'react'
import React from 'react'

import Wrapper from '@/components/shared/ui/Wrapper/Wrapper'
import UserProfileHeader from '@/components/users/shared/UserProfileHeader'
import { queryClient } from '@/config/queryClient'

// @ts-ignore

interface IPropTypes {
  children: ReactNode
}

export default function UserProfileLayout(props: IPropTypes) {
  return (
    <Wrapper>
      <QueryClientProvider client={queryClient}>
        <UserProfileHeader />
        {props.children}
      </QueryClientProvider>
    </Wrapper>
  )
}
